import React, { FC, useContext, useEffect, useState } from "react";
import { Dropdown } from "flowbite-react";
import { HiBell, HiX } from "react-icons/hi";
import { ChatContext, ChatContextInterface } from "../components/MSRContext";

const Notifications: FC = function () {
    const { notificationController, setnotifCount } = useContext(ChatContext) as ChatContextInterface;
    const [notifications, setNotifications] = useState(notificationController.Notifications);

    useEffect(() => {
        const handleNotificationsUpdate = () => {
            console.log("Notifications updated, refreshing component");
            setNotifications([...notificationController.Notifications]);
            setnotifCount(notificationController.Notifications.length);
        };

        window.addEventListener("notificationsUpdate", handleNotificationsUpdate);
        return () => {
            window.removeEventListener("notificationsUpdate", handleNotificationsUpdate);
        };
    }, [notificationController, setnotifCount]);

    useEffect(() => {
        setNotifications([...notificationController.Notifications]);
        setnotifCount(notificationController.Notifications.length);
    }, [notificationController]);

    const handleRemoveNotification = (notificationId: string) => {
        notificationController.removeNotificationById(notificationId);
    };

    // const formatTimeAgo = (createdTime: Date) => {
    //     if (!createdTime) return 'Recently';

    //     const now = new Date().getTime();
    //     const created = createdTime.getTime();
    //     const diffMinutes = Math.floor((now - created) / (1000 * 60));

    //     if (diffMinutes < 1) return 'Just now';
    //     if (diffMinutes < 60) return `${diffMinutes}m ago`;
    //     const diffHours = Math.floor(diffMinutes / 60);
    //     if (diffHours < 24) return `${diffHours}h ago`;
    //     const diffDays = Math.floor(diffHours / 24);
    //     return `${diffDays}d ago`;
    // };

    return (
        <Dropdown
            arrowIcon={false}
            inline
            label={
                <span className="relative p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200">
                    <span className="sr-only">Notifications</span>
                    <HiBell className="text-xl text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white transition-colors duration-200" />
                    {notifications.length > 0 && (
                        <span className="absolute flex items-center justify-center min-w-[18px] h-[18px] text-xs font-medium text-white rounded-full bg-blue-500 -top-1 -right-1 animate-pulse">
                            {notifications.length}
                        </span>
                    )}
                </span>
            }
        >
            <div className="w-80 max-w-sm">
                {/* Header */}
                <div className="flex items-center justify-between px-4 py-3 text-sm font-semibold text-gray-700 bg-gray-50 rounded-t-lg dark:bg-gray-700 dark:text-gray-300 border-b border-gray-200 dark:border-gray-600">
                    <span className="flex items-center gap-2">
                        <HiBell className="text-base" />
                        Notifications
                    </span>
                    {notifications.length > 0 && (
                        <span className="text-xs bg-gray-200 dark:bg-gray-600 px-2 py-1 rounded-full">
                            {notifications.length}
                        </span>
                    )}
                </div>
                <div className="max-h-96 overflow-y-auto">
                    {notifications.length > 0 ? (
                        notifications.map((notification, index) => (
                            <div
                                key={notification.id}
                                className={`relative px-4 py-3 border-b border-gray-100 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors duration-200 ${index === notifications.length - 1 ? 'border-b-0' : ''
                                    }`}
                            >
                                <div className="flex items-start gap-3">
                                    {/* Notification Icon */}
                                    <div className="flex-shrink-0 mt-1">
                                        <div className="w-8 h-8 bg-gradient-to-br from-blue-400 to-indigo-500 rounded-full flex items-center justify-center">
                                            <NotificationIcon />
                                        </div>
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <div className="flex items-start justify-between gap-2">
                                            <div className="flex-1 min-w-0">
                                                <p className="text-sm text-gray-900 dark:text-white leading-relaxed mb-2">
                                                    {notification.detail}
                                                </p>
                                                {/* <p className="text-xs text-gray-500 dark:text-gray-400">
                                                    {formatTimeAgo(notification.timestamp)}
                                                </p> */}
                                            </div>
                                            <button
                                                onClick={() => handleRemoveNotification(notification.id)}
                                                className="flex-shrink-0 p-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 rounded transition-colors duration-200"
                                                title="Remove notification"
                                            >
                                                <HiX className="w-4 h-4" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="px-4 py-8 text-center">
                            <div className="flex flex-col items-center gap-2">
                                <div className="w-12 h-12 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center">
                                    <HiBell className="w-6 h-6 text-gray-400" />
                                </div>
                                <p className="text-sm font-medium text-gray-500 dark:text-gray-400">No notifications</p>
                                <p className="text-xs text-gray-400 dark:text-gray-500">You're all caught up!</p>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Dropdown>
    );
};

const NotificationIcon: FC = function () {
    return (
        <svg
            className="w-4 h-4 text-white"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                d="M18 13V5a2 2 0 00-2-2H4a2 2 0 00-2 2v8a2 2 0 002 2h3l3 3 3-3h3a2 2 0 002-2zM5 7a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1zm1 3a1 1 0 100 2h3a1 1 0 100-2H6z"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Notifications;